export const utils = {
  is_mobile_ios: () =>
    window.navigator.userAgent.match(/iPhone/i) ||
    window.navigator.userAgent.match(/iPad/i),
};
